import {
  Companion_getInstance1cc7a4v9g7e6l as Companion_getInstance,
  ProjectMessage3vmbacgk5u7x3 as ProjectMessage,
  PayAppMessageReference2hrqvwim22vlh as PayAppMessageReference,
  ChangeRequestMessageReference3iran64qsoyry as ChangeRequestMessageReference,
  MessageReply3razfyxlh5p4t as MessageReply,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { ServerFile1t91jzpzoixwe as ServerFile } from '../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(ProjectMessage_project_getInstance());
}
function get_referencesPayApp(_this__u8e3s4) {
  return _this__u8e3s4.prop(ProjectMessage_referencesPayApp_getInstance());
}
function get_referencesChangeRequest(_this__u8e3s4) {
  return _this__u8e3s4.prop(ProjectMessage_referencesChangeRequest_getInstance());
}
function get_sent(_this__u8e3s4) {
  return _this__u8e3s4.prop(ProjectMessage_sent_getInstance());
}
function get_sender(_this__u8e3s4) {
  return _this__u8e3s4.prop(ProjectMessage_sender_getInstance());
}
function get_readBy(_this__u8e3s4) {
  return _this__u8e3s4.prop(ProjectMessage_readBy_getInstance());
}
function prepareProjectMessageFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [ProjectMessage__id_getInstance(), ProjectMessage_project_getInstance(), ProjectMessage_sender_getInstance(), ProjectMessage_senderName_getInstance(), ProjectMessage_senderIcon_getInstance(), ProjectMessage_clientMessage_getInstance(), ProjectMessage_sent_getInstance(), ProjectMessage_message_getInstance(), ProjectMessage_readBy_getInstance(), ProjectMessage_replyingToMessage_getInstance(), ProjectMessage_referencesChangeRequest_getInstance(), ProjectMessage_referencesPayApp_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function ProjectMessage_project$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function ProjectMessage_project$_get_name_$ref_ajmt8r() {
  return (p0) => p0.k20();
}
function ProjectMessage_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectMessage_project$_get_serializer_$ref_ljhc84() {
  return (p0) => p0.j2j();
}
function ProjectMessage_project$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function ProjectMessage_project$_get_annotations_$ref_ce7yow() {
  return (p0) => p0.bz();
}
var ProjectMessage_projectClass;
function ProjectMessage_project() {
  if (ProjectMessage_projectClass === VOID) {
    class $ {
      constructor() {
        ProjectMessage_project_instance = this;
        var tmp = this;
        tmp.e7p_1 = lazy(ProjectMessage_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f7p_1 = lazy(ProjectMessage_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g7p_1 = lazy(ProjectMessage_project$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.e7p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectMessage_project$_get_name_$ref_ajmt8r(), null);
        return tmp0.f2();
      }
      h7p(receiver) {
        return receiver.j7p_1;
      }
      m2j(receiver) {
        return this.h7p(receiver instanceof ProjectMessage() ? receiver : THROW_CCE());
      }
      u7p(receiver, value) {
        return receiver.v7p(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectMessage() ? receiver : THROW_CCE();
        return this.u7p(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.f7p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectMessage_project$_get_serializer_$ref_ljhc84(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g7p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectMessage_project$_get_annotations_$ref_ce7yow(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectMessage_project', VOID, VOID, [SerializableProperty()]);
    ProjectMessage_projectClass = $;
  }
  return ProjectMessage_projectClass;
}
var ProjectMessage_project_instance;
function ProjectMessage_project_getInstance() {
  if (ProjectMessage_project_instance === VOID)
    new (ProjectMessage_project())();
  return ProjectMessage_project_instance;
}
function ProjectMessage_referencesPayApp$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(11);
}
function ProjectMessage_referencesPayApp$_get_name_$ref_l0o81() {
  return (p0) => p0.k20();
}
function ProjectMessage_referencesPayApp$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[11];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectMessage_referencesPayApp$_get_serializer_$ref_csekze() {
  return (p0) => p0.j2j();
}
function ProjectMessage_referencesPayApp$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(11);
}
function ProjectMessage_referencesPayApp$_get_annotations_$ref_p7aq2y() {
  return (p0) => p0.bz();
}
var ProjectMessage_referencesPayAppClass;
function ProjectMessage_referencesPayApp() {
  if (ProjectMessage_referencesPayAppClass === VOID) {
    class $ {
      constructor() {
        ProjectMessage_referencesPayApp_instance = this;
        var tmp = this;
        tmp.w7p_1 = lazy(ProjectMessage_referencesPayApp$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x7p_1 = lazy(ProjectMessage_referencesPayApp$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y7p_1 = lazy(ProjectMessage_referencesPayApp$annotations$delegate$lambda);
        this.z7p_1 = null;
        this.a7q_1 = 'null';
      }
      k20() {
        var tmp0 = this.w7p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectMessage_referencesPayApp$_get_name_$ref_l0o81(), null);
        return tmp0.f2();
      }
      h7p(receiver) {
        return receiver.t7p_1;
      }
      m2j(receiver) {
        return this.h7p(receiver instanceof ProjectMessage() ? receiver : THROW_CCE());
      }
      b7q(receiver, value) {
        return receiver.v7p(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectMessage() ? receiver : THROW_CCE();
        return this.b7q(tmp, (value == null ? true : value instanceof PayAppMessageReference()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.x7p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectMessage_referencesPayApp$_get_serializer_$ref_csekze(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y7p_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectMessage_referencesPayApp$_get_annotations_$ref_p7aq2y(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectMessage_referencesPayApp', VOID, VOID, [SerializableProperty()]);
    ProjectMessage_referencesPayAppClass = $;
  }
  return ProjectMessage_referencesPayAppClass;
}
var ProjectMessage_referencesPayApp_instance;
function ProjectMessage_referencesPayApp_getInstance() {
  if (ProjectMessage_referencesPayApp_instance === VOID)
    new (ProjectMessage_referencesPayApp())();
  return ProjectMessage_referencesPayApp_instance;
}
function ProjectMessage_referencesChangeRequest$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(10);
}
function ProjectMessage_referencesChangeRequest$_get_name_$ref_lexgb1() {
  return (p0) => p0.k20();
}
function ProjectMessage_referencesChangeRequest$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[10];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectMessage_referencesChangeRequest$_get_serializer_$ref_hx8xei() {
  return (p0) => p0.j2j();
}
function ProjectMessage_referencesChangeRequest$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(10);
}
function ProjectMessage_referencesChangeRequest$_get_annotations_$ref_3hhe76() {
  return (p0) => p0.bz();
}
var ProjectMessage_referencesChangeRequestClass;
function ProjectMessage_referencesChangeRequest() {
  if (ProjectMessage_referencesChangeRequestClass === VOID) {
    class $ {
      constructor() {
        ProjectMessage_referencesChangeRequest_instance = this;
        var tmp = this;
        tmp.c7q_1 = lazy(ProjectMessage_referencesChangeRequest$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d7q_1 = lazy(ProjectMessage_referencesChangeRequest$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e7q_1 = lazy(ProjectMessage_referencesChangeRequest$annotations$delegate$lambda);
        this.f7q_1 = null;
        this.g7q_1 = 'null';
      }
      k20() {
        var tmp0 = this.c7q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectMessage_referencesChangeRequest$_get_name_$ref_lexgb1(), null);
        return tmp0.f2();
      }
      h7p(receiver) {
        return receiver.s7p_1;
      }
      m2j(receiver) {
        return this.h7p(receiver instanceof ProjectMessage() ? receiver : THROW_CCE());
      }
      h7q(receiver, value) {
        return receiver.v7p(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectMessage() ? receiver : THROW_CCE();
        return this.h7q(tmp, (value == null ? true : value instanceof ChangeRequestMessageReference()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.d7q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectMessage_referencesChangeRequest$_get_serializer_$ref_hx8xei(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e7q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectMessage_referencesChangeRequest$_get_annotations_$ref_3hhe76(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectMessage_referencesChangeRequest', VOID, VOID, [SerializableProperty()]);
    ProjectMessage_referencesChangeRequestClass = $;
  }
  return ProjectMessage_referencesChangeRequestClass;
}
var ProjectMessage_referencesChangeRequest_instance;
function ProjectMessage_referencesChangeRequest_getInstance() {
  if (ProjectMessage_referencesChangeRequest_instance === VOID)
    new (ProjectMessage_referencesChangeRequest())();
  return ProjectMessage_referencesChangeRequest_instance;
}
function ProjectMessage_sent$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function ProjectMessage_sent$_get_name_$ref_f2pwq() {
  return (p0) => p0.k20();
}
function ProjectMessage_sent$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectMessage_sent$_get_serializer_$ref_sevb7() {
  return (p0) => p0.j2j();
}
function ProjectMessage_sent$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function ProjectMessage_sent$_get_annotations_$ref_8d3w4h() {
  return (p0) => p0.bz();
}
var ProjectMessage_sentClass;
function ProjectMessage_sent() {
  if (ProjectMessage_sentClass === VOID) {
    class $ {
      constructor() {
        ProjectMessage_sent_instance = this;
        var tmp = this;
        tmp.i7q_1 = lazy(ProjectMessage_sent$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j7q_1 = lazy(ProjectMessage_sent$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k7q_1 = lazy(ProjectMessage_sent$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.l7q_1 = get_default(Companion_instance).d1m();
        this.m7q_1 = 'now()';
      }
      k20() {
        var tmp0 = this.i7q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectMessage_sent$_get_name_$ref_f2pwq(), null);
        return tmp0.f2();
      }
      h7p(receiver) {
        return receiver.o7p_1;
      }
      m2j(receiver) {
        return this.h7p(receiver instanceof ProjectMessage() ? receiver : THROW_CCE());
      }
      n7q(receiver, value) {
        return receiver.v7p(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectMessage() ? receiver : THROW_CCE();
        return this.n7q(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.j7q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectMessage_sent$_get_serializer_$ref_sevb7(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k7q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectMessage_sent$_get_annotations_$ref_8d3w4h(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectMessage_sent', VOID, VOID, [SerializableProperty()]);
    ProjectMessage_sentClass = $;
  }
  return ProjectMessage_sentClass;
}
var ProjectMessage_sent_instance;
function ProjectMessage_sent_getInstance() {
  if (ProjectMessage_sent_instance === VOID)
    new (ProjectMessage_sent())();
  return ProjectMessage_sent_instance;
}
function ProjectMessage_sender$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function ProjectMessage_sender$_get_name_$ref_jxkzot() {
  return (p0) => p0.k20();
}
function ProjectMessage_sender$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectMessage_sender$_get_serializer_$ref_2mwzzu() {
  return (p0) => p0.j2j();
}
function ProjectMessage_sender$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function ProjectMessage_sender$_get_annotations_$ref_qt00ea() {
  return (p0) => p0.bz();
}
var ProjectMessage_senderClass;
function ProjectMessage_sender() {
  if (ProjectMessage_senderClass === VOID) {
    class $ {
      constructor() {
        ProjectMessage_sender_instance = this;
        var tmp = this;
        tmp.o7q_1 = lazy(ProjectMessage_sender$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.p7q_1 = lazy(ProjectMessage_sender$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.q7q_1 = lazy(ProjectMessage_sender$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.o7q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectMessage_sender$_get_name_$ref_jxkzot(), null);
        return tmp0.f2();
      }
      h7p(receiver) {
        return receiver.k7p_1;
      }
      m2j(receiver) {
        return this.h7p(receiver instanceof ProjectMessage() ? receiver : THROW_CCE());
      }
      u7p(receiver, value) {
        return receiver.v7p(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectMessage() ? receiver : THROW_CCE();
        return this.u7p(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.p7q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectMessage_sender$_get_serializer_$ref_2mwzzu(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.q7q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectMessage_sender$_get_annotations_$ref_qt00ea(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectMessage_sender', VOID, VOID, [SerializableProperty()]);
    ProjectMessage_senderClass = $;
  }
  return ProjectMessage_senderClass;
}
var ProjectMessage_sender_instance;
function ProjectMessage_sender_getInstance() {
  if (ProjectMessage_sender_instance === VOID)
    new (ProjectMessage_sender())();
  return ProjectMessage_sender_instance;
}
function ProjectMessage_readBy$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(8);
}
function ProjectMessage_readBy$_get_name_$ref_568xpn() {
  return (p0) => p0.k20();
}
function ProjectMessage_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectMessage_readBy$_get_serializer_$ref_v6p09e() {
  return (p0) => p0.j2j();
}
function ProjectMessage_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(8);
}
function ProjectMessage_readBy$_get_annotations_$ref_bkch1y() {
  return (p0) => p0.bz();
}
var ProjectMessage_readByClass;
function ProjectMessage_readBy() {
  if (ProjectMessage_readByClass === VOID) {
    class $ {
      constructor() {
        ProjectMessage_readBy_instance = this;
        var tmp = this;
        tmp.r7q_1 = lazy(ProjectMessage_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s7q_1 = lazy(ProjectMessage_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t7q_1 = lazy(ProjectMessage_readBy$annotations$delegate$lambda);
        this.u7q_1 = emptySet();
        this.v7q_1 = 'emptySet()';
      }
      k20() {
        var tmp0 = this.r7q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectMessage_readBy$_get_name_$ref_568xpn(), null);
        return tmp0.f2();
      }
      h7p(receiver) {
        return receiver.q7p_1;
      }
      m2j(receiver) {
        return this.h7p(receiver instanceof ProjectMessage() ? receiver : THROW_CCE());
      }
      w7q(receiver, value) {
        return receiver.v7p(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectMessage() ? receiver : THROW_CCE();
        return this.w7q(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.s7q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectMessage_readBy$_get_serializer_$ref_v6p09e(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t7q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectMessage_readBy$_get_annotations_$ref_bkch1y(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectMessage_readBy', VOID, VOID, [SerializableProperty()]);
    ProjectMessage_readByClass = $;
  }
  return ProjectMessage_readByClass;
}
var ProjectMessage_readBy_instance;
function ProjectMessage_readBy_getInstance() {
  if (ProjectMessage_readBy_instance === VOID)
    new (ProjectMessage_readBy())();
  return ProjectMessage_readBy_instance;
}
function ProjectMessage__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function ProjectMessage__id$_get_name_$ref_7yd2kq() {
  return (p0) => p0.k20();
}
function ProjectMessage__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectMessage__id$_get_serializer_$ref_vt9avx() {
  return (p0) => p0.j2j();
}
function ProjectMessage__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function ProjectMessage__id$_get_annotations_$ref_7v4ocf() {
  return (p0) => p0.bz();
}
var ProjectMessage__idClass;
function ProjectMessage__id() {
  if (ProjectMessage__idClass === VOID) {
    class $ {
      constructor() {
        ProjectMessage__id_instance = this;
        var tmp = this;
        tmp.x7q_1 = lazy(ProjectMessage__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y7q_1 = lazy(ProjectMessage__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z7q_1 = lazy(ProjectMessage__id$annotations$delegate$lambda);
        this.a7r_1 = Companion_getInstance_0().m2p();
        this.b7r_1 = 'UUID.random()';
      }
      k20() {
        var tmp0 = this.x7q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectMessage__id$_get_name_$ref_7yd2kq(), null);
        return tmp0.f2();
      }
      h7p(receiver) {
        return receiver.i7p_1;
      }
      m2j(receiver) {
        return this.h7p(receiver instanceof ProjectMessage() ? receiver : THROW_CCE());
      }
      u7p(receiver, value) {
        return receiver.v7p(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectMessage() ? receiver : THROW_CCE();
        return this.u7p(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.y7q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectMessage__id$_get_serializer_$ref_vt9avx(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z7q_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectMessage__id$_get_annotations_$ref_7v4ocf(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectMessage__id', VOID, VOID, [SerializableProperty()]);
    ProjectMessage__idClass = $;
  }
  return ProjectMessage__idClass;
}
var ProjectMessage__id_instance;
function ProjectMessage__id_getInstance() {
  if (ProjectMessage__id_instance === VOID)
    new (ProjectMessage__id())();
  return ProjectMessage__id_instance;
}
function ProjectMessage_senderName$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function ProjectMessage_senderName$_get_name_$ref_qsmo9q() {
  return (p0) => p0.k20();
}
function ProjectMessage_senderName$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectMessage_senderName$_get_serializer_$ref_8qj951() {
  return (p0) => p0.j2j();
}
function ProjectMessage_senderName$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function ProjectMessage_senderName$_get_annotations_$ref_2ttpxz() {
  return (p0) => p0.bz();
}
var ProjectMessage_senderNameClass;
function ProjectMessage_senderName() {
  if (ProjectMessage_senderNameClass === VOID) {
    class $ {
      constructor() {
        ProjectMessage_senderName_instance = this;
        var tmp = this;
        tmp.c7r_1 = lazy(ProjectMessage_senderName$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d7r_1 = lazy(ProjectMessage_senderName$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e7r_1 = lazy(ProjectMessage_senderName$annotations$delegate$lambda);
        this.f7r_1 = '';
        this.g7r_1 = '""';
      }
      k20() {
        var tmp0 = this.c7r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectMessage_senderName$_get_name_$ref_qsmo9q(), null);
        return tmp0.f2();
      }
      h7p(receiver) {
        return receiver.l7p_1;
      }
      m2j(receiver) {
        return this.h7p(receiver instanceof ProjectMessage() ? receiver : THROW_CCE());
      }
      h7r(receiver, value) {
        return receiver.v7p(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectMessage() ? receiver : THROW_CCE();
        return this.h7r(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.d7r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectMessage_senderName$_get_serializer_$ref_8qj951(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e7r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectMessage_senderName$_get_annotations_$ref_2ttpxz(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectMessage_senderName', VOID, VOID, [SerializableProperty()]);
    ProjectMessage_senderNameClass = $;
  }
  return ProjectMessage_senderNameClass;
}
var ProjectMessage_senderName_instance;
function ProjectMessage_senderName_getInstance() {
  if (ProjectMessage_senderName_instance === VOID)
    new (ProjectMessage_senderName())();
  return ProjectMessage_senderName_instance;
}
function ProjectMessage_senderIcon$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function ProjectMessage_senderIcon$_get_name_$ref_l66q6k() {
  return (p0) => p0.k20();
}
function ProjectMessage_senderIcon$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectMessage_senderIcon$_get_serializer_$ref_uc2vjn() {
  return (p0) => p0.j2j();
}
function ProjectMessage_senderIcon$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function ProjectMessage_senderIcon$_get_annotations_$ref_x3piqx() {
  return (p0) => p0.bz();
}
var ProjectMessage_senderIconClass;
function ProjectMessage_senderIcon() {
  if (ProjectMessage_senderIconClass === VOID) {
    class $ {
      constructor() {
        ProjectMessage_senderIcon_instance = this;
        var tmp = this;
        tmp.i7r_1 = lazy(ProjectMessage_senderIcon$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j7r_1 = lazy(ProjectMessage_senderIcon$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k7r_1 = lazy(ProjectMessage_senderIcon$annotations$delegate$lambda);
        this.l7r_1 = null;
        this.m7r_1 = 'null';
      }
      k20() {
        var tmp0 = this.i7r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectMessage_senderIcon$_get_name_$ref_l66q6k(), null);
        return tmp0.f2();
      }
      n7r(receiver) {
        return receiver.m7p_1;
      }
      m2j(receiver) {
        var tmp = this.n7r(receiver instanceof ProjectMessage() ? receiver : THROW_CCE());
        return tmp == null ? null : new (ServerFile())(tmp);
      }
      o7r(receiver, value) {
        return receiver.v7p(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectMessage() ? receiver : THROW_CCE();
        var tmp_0;
        if (value == null ? true : value instanceof ServerFile()) {
          var tmp_1 = value;
          tmp_0 = tmp_1 == null ? null : tmp_1.n2n_1;
        } else {
          tmp_0 = THROW_CCE();
        }
        return this.o7r(tmp, tmp_0);
      }
      j2j() {
        var tmp0 = this.j7r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectMessage_senderIcon$_get_serializer_$ref_uc2vjn(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k7r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectMessage_senderIcon$_get_annotations_$ref_x3piqx(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectMessage_senderIcon', VOID, VOID, [SerializableProperty()]);
    ProjectMessage_senderIconClass = $;
  }
  return ProjectMessage_senderIconClass;
}
var ProjectMessage_senderIcon_instance;
function ProjectMessage_senderIcon_getInstance() {
  if (ProjectMessage_senderIcon_instance === VOID)
    new (ProjectMessage_senderIcon())();
  return ProjectMessage_senderIcon_instance;
}
function ProjectMessage_clientMessage$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function ProjectMessage_clientMessage$_get_name_$ref_b6bnpk() {
  return (p0) => p0.k20();
}
function ProjectMessage_clientMessage$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectMessage_clientMessage$_get_serializer_$ref_77ed0f() {
  return (p0) => p0.j2j();
}
function ProjectMessage_clientMessage$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function ProjectMessage_clientMessage$_get_annotations_$ref_qdq3y5() {
  return (p0) => p0.bz();
}
var ProjectMessage_clientMessageClass;
function ProjectMessage_clientMessage() {
  if (ProjectMessage_clientMessageClass === VOID) {
    class $ {
      constructor() {
        ProjectMessage_clientMessage_instance = this;
        var tmp = this;
        tmp.p7r_1 = lazy(ProjectMessage_clientMessage$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q7r_1 = lazy(ProjectMessage_clientMessage$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r7r_1 = lazy(ProjectMessage_clientMessage$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.p7r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectMessage_clientMessage$_get_name_$ref_b6bnpk(), null);
        return tmp0.f2();
      }
      h7p(receiver) {
        return receiver.n7p_1;
      }
      m2j(receiver) {
        return this.h7p(receiver instanceof ProjectMessage() ? receiver : THROW_CCE());
      }
      s7r(receiver, value) {
        return receiver.v7p(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectMessage() ? receiver : THROW_CCE();
        return this.s7r(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.q7r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectMessage_clientMessage$_get_serializer_$ref_77ed0f(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r7r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectMessage_clientMessage$_get_annotations_$ref_qdq3y5(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectMessage_clientMessage', VOID, VOID, [SerializableProperty()]);
    ProjectMessage_clientMessageClass = $;
  }
  return ProjectMessage_clientMessageClass;
}
var ProjectMessage_clientMessage_instance;
function ProjectMessage_clientMessage_getInstance() {
  if (ProjectMessage_clientMessage_instance === VOID)
    new (ProjectMessage_clientMessage())();
  return ProjectMessage_clientMessage_instance;
}
function ProjectMessage_message$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function ProjectMessage_message$_get_name_$ref_hh3vab() {
  return (p0) => p0.k20();
}
function ProjectMessage_message$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectMessage_message$_get_serializer_$ref_te0t1m() {
  return (p0) => p0.j2j();
}
function ProjectMessage_message$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function ProjectMessage_message$_get_annotations_$ref_3rxd82() {
  return (p0) => p0.bz();
}
var ProjectMessage_messageClass;
function ProjectMessage_message() {
  if (ProjectMessage_messageClass === VOID) {
    class $ {
      constructor() {
        ProjectMessage_message_instance = this;
        var tmp = this;
        tmp.t7r_1 = lazy(ProjectMessage_message$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u7r_1 = lazy(ProjectMessage_message$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v7r_1 = lazy(ProjectMessage_message$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.t7r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectMessage_message$_get_name_$ref_hh3vab(), null);
        return tmp0.f2();
      }
      h7p(receiver) {
        return receiver.p7p_1;
      }
      m2j(receiver) {
        return this.h7p(receiver instanceof ProjectMessage() ? receiver : THROW_CCE());
      }
      h7r(receiver, value) {
        return receiver.v7p(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectMessage() ? receiver : THROW_CCE();
        return this.h7r(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.u7r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectMessage_message$_get_serializer_$ref_te0t1m(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v7r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectMessage_message$_get_annotations_$ref_3rxd82(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectMessage_message', VOID, VOID, [SerializableProperty()]);
    ProjectMessage_messageClass = $;
  }
  return ProjectMessage_messageClass;
}
var ProjectMessage_message_instance;
function ProjectMessage_message_getInstance() {
  if (ProjectMessage_message_instance === VOID)
    new (ProjectMessage_message())();
  return ProjectMessage_message_instance;
}
function ProjectMessage_replyingToMessage$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(9);
}
function ProjectMessage_replyingToMessage$_get_name_$ref_h11xow() {
  return (p0) => p0.k20();
}
function ProjectMessage_replyingToMessage$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectMessage_replyingToMessage$_get_serializer_$ref_symeg9() {
  return (p0) => p0.j2j();
}
function ProjectMessage_replyingToMessage$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(9);
}
function ProjectMessage_replyingToMessage$_get_annotations_$ref_tc8prv() {
  return (p0) => p0.bz();
}
var ProjectMessage_replyingToMessageClass;
function ProjectMessage_replyingToMessage() {
  if (ProjectMessage_replyingToMessageClass === VOID) {
    class $ {
      constructor() {
        ProjectMessage_replyingToMessage_instance = this;
        var tmp = this;
        tmp.w7r_1 = lazy(ProjectMessage_replyingToMessage$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x7r_1 = lazy(ProjectMessage_replyingToMessage$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y7r_1 = lazy(ProjectMessage_replyingToMessage$annotations$delegate$lambda);
        this.z7r_1 = null;
        this.a7s_1 = 'null';
      }
      k20() {
        var tmp0 = this.w7r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectMessage_replyingToMessage$_get_name_$ref_h11xow(), null);
        return tmp0.f2();
      }
      h7p(receiver) {
        return receiver.r7p_1;
      }
      m2j(receiver) {
        return this.h7p(receiver instanceof ProjectMessage() ? receiver : THROW_CCE());
      }
      b7s(receiver, value) {
        return receiver.v7p(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ProjectMessage() ? receiver : THROW_CCE();
        return this.b7s(tmp, (value == null ? true : value instanceof MessageReply()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.x7r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectMessage_replyingToMessage$_get_serializer_$ref_symeg9(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y7r_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectMessage_replyingToMessage$_get_annotations_$ref_tc8prv(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectMessage_replyingToMessage', VOID, VOID, [SerializableProperty()]);
    ProjectMessage_replyingToMessageClass = $;
  }
  return ProjectMessage_replyingToMessageClass;
}
var ProjectMessage_replyingToMessage_instance;
function ProjectMessage_replyingToMessage_getInstance() {
  if (ProjectMessage_replyingToMessage_instance === VOID)
    new (ProjectMessage_replyingToMessage())();
  return ProjectMessage_replyingToMessage_instance;
}
//region block: exports
export {
  prepareProjectMessageFields as prepareProjectMessageFields29a8dqjn3j22h,
  get_project as get_project1t10doy5antl1,
  get_readBy as get_readByax5xrch6yvl3,
  get_referencesChangeRequest as get_referencesChangeRequest3ru7mjlfmk3mg,
  get_referencesPayApp as get_referencesPayApp2j107w4s6lx3b,
  get_sender as get_senderfnqbuybwjyzf,
  get_sent as get_sent1fielv150x6ow,
};
//endregion

//# sourceMappingURL=ProjectMessageFields.mjs.map
